import * as React from 'react';
import './index.css';

// 导出该组件供给其他模块使用
export default class HelloWebpack extends React.Component {
  render() {
    return (
      <h1 className="hello-component">Hello, Webpack</h1>
    )
  }
}


// WEBPACK FOOTER //
// ./src/index.js